{
  "serie": {
    "display": "Display the chart",
    "hide": "Hide the chart",
    "remove": "Remove the cart",
    "displaySettings": "Display the chart settings",
    "selectColor": "Click to select a color",
    "color": "Color",
    "type": "Type",
    "types": {
      "line": "Line",
      "bar": "Bar"
    }
  }
}
